import React from 'react';
import TextAreaWithCounter from '../UtilComponents/TextAreaWithCounter';
import PropTypes from 'prop-types';

function SeekBillingReference({ answers, setAnswers }) {
  return (
    <TextAreaWithCounter
      title="Seek Billing Reference (Optional)"
      value={answers.billing_reference}
      setValue={(value) => setAnswers({ ...answers, billing_reference: value })}
      maxLength={50}
      helperText="Include a purchase order or reference to appear on your SEEK invoice"
    />
  );
}

SeekBillingReference.propTypes = {
  answers: PropTypes.object.isRequired,
  setAnswers: PropTypes.func.isRequired
};

export default SeekBillingReference;
